import { createGlobalStyle } from "styled-components";

const Global = createGlobalStyle`
	.steps-container .RSPBprogressBar {
		gap: 6.5rem;
	}

	.steps-container .RSPBprogressBar .RSPBstep .step {
		border-radius: 50%;
		padding: .8rem 1rem;
		color: var(--white);
	}
	
	.steps-container .RSPBprogressBar .RSPBstep .step.step-active {
		background-color: var(--color-action-primary-default) !important;
	}

	.steps-container .RSPBprogressBar .RSPBstep .step.step-inactive {
		background-color: var(--color-neutral-3);
	}

	.steps-container .RSPBprogressBar .RSPBstep .step.step-done {
		background-color: var(--color-state-success);
	}

	.form-group.required .form-label:after {
		content:" *";
		color:var(--color-state-error);
	}
	.form-group .radio-group {
		gap: 1rem;
	}

	.form-group .radio-group label {
		gap: 0.5rem;
	}

	.form-group .form-control.form-field {
		transition: opacity .2s ease-in-out;
	}
	
	.form-group .form-control.form-field:disabled {
		opacity: 40%;
	}
	
	.modal .modal-dialog .custom-modal-content {
		transform: translateY(-50%);
    	top: 50%;
	}
	.custom-modal-backdrop {
		opacity: 60%;
	}

	sinpol-user-form-element .btn.btn-primary.disabled {
		pointer-events: none;
		opacity: .5;
	}
`;

export default Global;
